import { randBoolean, randSentence } from '@ngneat/falso';
import { initVersionedSchema } from '@principle-theorem/editor';
import { INote } from '@principle-theorem/principle-core/interfaces';
import { BaseFirestoreMock, Properties } from '@principle-theorem/shared';
import { v4 as uuid } from 'uuid';

export class NoteMock
  extends BaseFirestoreMock<Properties<INote>>
  implements Properties<INote>
{
  uid = uuid();
  content = initVersionedSchema(randSentence());
  pinned = randBoolean();
}
